import { array, objectOf } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ProductModal from '@features/trend-research/components/common/ProductModal';
import { capitalizeFirstLetter } from '@features/trend-research/utils/utils';
import AddMoodBoard from '@features/trend-research/components/moodboard/addMoodboard';

const Product = ({ allProducts }) => {
	const [showModal, setShowModal] = useState(false);
	const [isAddToMoodBoard, setIsAddToMoodBoard] = useState(false);
	const [isOpenMoodBoardModal, setIsOpenMoodBoardModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [selectedSource, setSelectedSource] = useState('');

	const location = useLocation();
	const { source } = location?.state || {};
	const selectedItem = JSON.parse(sessionStorage.getItem('selectedItem')) || {};
	useEffect(() => {
		if (source) {
			setSelectedSource(source);
		} else if (selectedItem) {
			setSelectedSource(selectedItem?.source);
		}
	}, [source, selectedItem]);

	const showProductModal = (product) => {
		setShowModal(true);
		setSelectedProduct(product);
	};

	const onClose = () => {
		setShowModal(false);
		setSelectedProduct(null);
	};

	const handleMoodboardClick = async (product) => {
		setIsAddToMoodBoard(true);
		setIsOpenMoodBoardModal(true);
		setSelectedProduct(product);
	};

	const renderInfluencerInfo = (product) => {
		return (
			<div
				className="instram-button d-flex align-items-center justify-content-center cursor-pointer"
				onClick={() => window.open(product?.postUrl, '_blank')}
			>
				<img
					className="inst-img"
					src={`${process.env.PUBLIC_URL}/icons/arrow_forward_dark.svg`}
					width={16}
					height={16}
					alt=""
				/>
				<img
					className="avatar mx-2"
					src={product?.userProfilePicUrl || `${process.env.PUBLIC_URL}/images/profile_avatar.png`}
					alt=""
					width={18}
					height={18}
					loading="lazy"
				/>
				<p className="radius weight-500 gray_dark_01">{product?.userName}</p>
			</div>
		);
	};

	const renderBrandLogo = (product) => {
		return (
			<div className="brand-logo">
				{product?.brandLogoDocResponse?.docUrl && (
					<img src={product?.brandLogoDocResponse?.docUrl} alt="logo" loading="lazy" />
				)}
			</div>
		);
	};

	return (
		<div className="all-products-item">
			{isOpenMoodBoardModal && (
				<AddMoodBoard
					isAddToMoodBoard={isAddToMoodBoard}
					setIsAddToMoodBoard={setIsAddToMoodBoard}
					isOpenMoodBoardModal={isOpenMoodBoardModal}
					setIsOpenMoodBoardModal={setIsOpenMoodBoardModal}
					selectedProduct={selectedProduct}
				/>
			)}

			{allProducts &&
				allProducts?.length > 0 &&
				allProducts?.map((product) => (
					<div
						key={product?.id}
						className="single-design-card trend-product-card"
						onClick={() => showProductModal(product)}
					>
						<div className="card-top">
							<img
								src={
									product?.imageUrl?.startsWith('https:')
										? product?.imageUrl
										: `${process.env.PUBLIC_URL}/images/trend/demo.jpg`
								}
								alt="card-image"
								loading="lazy"
							/>
							<div className="card-overly">
								<div className="logo-and-fab d-flex justify-content-between">
									{selectedSource === 'Brand' && renderBrandLogo(product)}
									{selectedSource === 'Instagram' && renderInfluencerInfo(product)}
									<div className="custom-chekbox" onClick={(e) => e.stopPropagation()}>
										<div className="form-group d-flex">
											{/* {selectedMoodboard?.id !== id && ( */}
											<img
												src={`${process.env.PUBLIC_URL}/icons/not-favorite.svg`}
												alt="not-favourite"
												className="add-to-favorite"
												onClick={() => handleMoodboardClick(product)}
											/>
											{/* )}  */}
											{/* {addToMoodBoard && selectedMoodboard.id === product?.id && (
												<img
													src={`${process.env.PUBLIC_URL}/icons/favorite.svg`}
													alt="favourite"
													className="add-to-favorite"
													//onClick={handleMoodboardClick}
												/>
											)} */}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="card-content">
							<p className="design-title semibold-14">
								{/* <CustomTooltip
									text={`${capitalizeFirstLetter(product.name)}`}
									position={POSITIONS.BOTTOM}
									arrowCenter={true}
									className="custom-tooltip"
								> */}
								{capitalizeFirstLetter(`${product?.name}`)}
								{/* </CustomTooltip> */}
							</p>
							{source === 'Brand' && (
								<ul className="common-list-component mt-1">
									<li>${product?.price}</li>
									<li>{product?.brandName}</li>
								</ul>
							)}
						</div>
					</div>
				))}

			{showModal && selectedProduct && <ProductModal onClose={onClose} id={selectedProduct?.id} />}
		</div>
	);
};

Product.propTypes = {
	allProducts: objectOf(array)
};

export default Product;
